import {Component, inject, OnInit} from '@angular/core'
import {ThemeService} from './shared/services/theme.service'
import { RouterOutlet } from '@angular/router';
import { NotificationComponent } from './core/components/notification/notification.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [NotificationComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly themeService = inject(ThemeService)

  ngOnInit(): void {
    this.themeService.init()
  }
}
